import { render, staticRenderFns } from "./otePracticeList.vue?vue&type=template&id=4e137cc2&scoped=true"
import script from "./otePracticeList.vue?vue&type=script&lang=js"
export * from "./otePracticeList.vue?vue&type=script&lang=js"
import style0 from "./otePracticeList.vue?vue&type=style&index=0&id=4e137cc2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e137cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e137cc2')) {
      api.createRecord('4e137cc2', component.options)
    } else {
      api.reload('4e137cc2', component.options)
    }
    module.hot.accept("./otePracticeList.vue?vue&type=template&id=4e137cc2&scoped=true", function () {
      api.rerender('4e137cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/exam/components/otePracticeList.vue"
export default component.exports